import * as React from 'react';
import * as blocks from '../components/_new/BlocksCourseStructure/style.module.scss';
export const blocksDataTeachers = [
  {
    bage: 'Модуль 1',
    title: 'Знакомство с методикой и первый опыт её применения в\u00A0учёбе',
    description:
      <>
        <p>
          С первых же уроков ребёнок будет оттачивать навыки, которые в будущем помогут ему достичь успехов в профессиональной карьере. Но практическую пользу от технологий эффективного обучения он увидит уже здесь и сейчас. Лёгкость в усвоении учебного материала, высокая результативность и удовольствие от процесса укрепят его веру в себя, расширят горизонт мышления. Качество знаний и успеваемость возрастёт, а время, которое нужно будет тратить на учёбу в школе и ВУЗе, — сократится.
        </p>
        <p>
          Уже на первых занятиях ребёнок научится лучше фокусировать внимание, а также быстро и прочно запоминать отдельные виды адаптированной информации. Кроме общих упражнений на развитие памяти и внимания, в модуль входят материалы по русскому языку, биологии и географии.
        </p>
        <p className={blocks.structure__blockResult}><strong>Результат модуля:</strong></p>
        <ul>
          <li><b>Навык высокой концентрации внимания (до 15 минут непрерывной работы)</b></li>
          <li><b>Базовое развитие внимания, памяти и воображения</b></li>
          <li><b>Навык запоминания парной информации, в том числе логически не связанной</b></li>
          <li><b>Освоение школьного материала: ребёнок выучит названия стран и столиц, до автоматизма отработает сложные
            случаи ударения в русских словах, запомнит несколько архаизмов и названия аминокислот</b></li>
        </ul>
      </>
  },

  {
    bage: 'Модуль 2',
    title: 'Сложные информационные объекты и\u00A0работа с\u00A0ними',
    description:
      <>
        <p>
          Информация, с которой мы имеем дело вне учебной ситуации, не всегда хорошо структурирована и не адаптирована для запоминания. Поэтому следующий этап курса — обеспечить ребёнку навыки работы со сложными информационными объектами. В курсе этот переход от простого к сложному реализован плавно, это позволит сохранить мотивацию для продолжения курса.
        </p>
        <p className={blocks.structure__blockResult}><strong>Результат модуля:</strong></p>
        <ul>
          <li><b>Навык высокой концентрации внимания до 30 минут</b></li>
          <li><b>Развитие внимания, памяти и воображения</b></li>
          <li><b>Умение быстрого запоминания иностранных слов на примере английского, греческого и латинского языка</b></li>
          <li><b>Навык запоминать последовательности</b></li>
          <li><b>Применение специальных технологий (метода лоций, метода Цицерона)</b></li>
          <li><b>Умение запоминать числовую информацию</b></li>
          <li><b>Первый опыт работы со сложными разнородными таблицами на примере таблицы Менделеева</b></li>
          <li><b>Навык поиска нужной информации в текстовом массиве</b></li>
          <li><b>Освоение школьного материала: исторические даты (Смутное время), аминокислоты, географические объекты, возбудители болезней, пары черепных нервов, витамины, латинские корни</b></li>
        </ul>
      </>
  },
  {
    bage: 'Модуль 3',
    title: 'Заключительный модуль развития памяти и переход к развитию логического мышления',
    description:
      <>
        <p>Третий модуль завершает формирование фундамента (базовых навыков) для всего дальнейшего обучения.</p>
        <p className={blocks.structure__blockResult}><strong>Результат модуля:</strong></p>
        <ul>
          <li><b>Навык высокой концентрации внимания до 45 минут</b></li>
          <li><b>Развитие внимания, памяти и воображения до высокого уровня</b></li>
          <li><b>Навык запоминания формул, таблиц, схем и карт</b></li>
          <li><b>Работа со сложными информационными объектами: теоремами, доказательствами, формулами, правилами,
            определениями</b></li>
          <li><b>Освоение материалов школьной программы: английской лексики и основных неправильных глаголов, отдельных
            тем по физической географии и политической географии РФ, дат из истории России VIII-XX веков, дат из
            всемирной истории и литературы, физических и математических формул, химических соединений (алканов), основ
            зоологии и анатомии</b></li>
        </ul>
        <div className={blocks.structure__blockTotal}>
          <p>По итогам первых трёх модулей ребёнок освоит техники и методы, которые позволят быстро и прочно
            запоминать, а также качественно воспроизводить не только школьный материал, но и любую адаптированную
            информацию.</p>
          <p>На основе этого опыта ребёнок осознает, что его возможности намного шире, чем он мог себе представить. Он
            научится самостоятельному управлению своим развитием, что укрепит его мотивацию и веру в себя.</p>
        </div>
      </>
  },
  {
    bage: 'Модуль 4',
    title: 'Методы работы с информацией',
    description:
      <>
        <p>На предыдущем этапе студент научился базовым техникам концентрации и запоминания.
          Если говорить образно, он пересел с печатной машинки за компьютер: его интеллектуальные возможности перешли на
          новый уровень, а скорость обучения возросла.
          Настало время развить навыки оператора, чтобы в дальнейшем он мог самостоятельно управлять такой комплексной
          системой, как его собственный интеллект.</p>
        <p className={blocks.structure__blockResult}><strong>Результат модуля:</strong></p>
        <ul>
          <li><b>Навык обнаружения причинно-следственных связей</b></li>
          <li><b>Навык работы с майнд-картами</b></li>
          <li><b>Навык работы с символами и символьной информацией</b></li>
          <li><b>Умение выбирать способ поиска информации</b></li>
          <li><b>Умение выбирать способ запоминания информации</b></li>
          <li><b>Умение классифицировать информацию по различным основаниям</b></li>
          <li><b>Умение применять теорию множеств для классифицирования</b></li>
          <li><b>Умение анализировать текст размером от одного до нескольких абзацев и сохранять главные тезисы в
            долговременную память</b></li>
          <li><b>Начало отработки навыков скорочтения</b></li>
          <li><b>Умение фокусировать внимание до 60 минут</b></li>
          <li><b>Освоение школьного материала: математических теорем, правил грамматики и русского языка</b></li>
        </ul>
      </>
  },
  {
    bage: 'Модуль 5',
    title: 'Термины и определения',
    description:
      <>
        <p>Профессионализм в любой области тесно связан с опытом работы с терминологией. Школьная программа включает
          определённый набор терминов.
          Каждая профессия расширяет эту базу, добавляя новые значения к старым. Поэтому мы посвятили отдельный модуль
          работе с терминами и определениями — ребёнок на школьном материале получит навык работы с терминологией.
          Применяя его к любой сфере, он сможет быстро осваивать любые специальности и совершенствоваться
          профессионально.</p>
        <p className={blocks.structure__blockResult}><strong>Результат модуля:</strong></p>
        <ul>
          <li><b>Ребёнок научится запоминать термины и определения</b></li>
          <li><b>Студент освоит ранее неизвестные значения</b></li>
          <li><b>Студент научится связывать новую информацию с уже имеющимися в памяти сведениями</b></li>
          <li><b>Студент приобретёт навык выделения главного в тексте</b></li>
          <li><b>Студент освоит школьный материал: выучит определения из курса по истории, географии, обществознанию</b>
          </li>
        </ul>
      </>
  },
  {
    bage: 'Модуль 6',
    title: 'Самостоятельно пройти учебник за неделю? Легко!',
    description:
      <>
        <p>Этот модуль поставит навык эффективной работы с большим объёмом разнородной информации.
          Ребёнок сможет охватить вниманием уже не абзац или параграф, а целый учебник.
          Он сделает это с помощью специальных алгоритмов сначала под руководством наших педагогов, затем
          самостоятельно.
          Для того, чтобы работать с такими объёмами текста, необходимо владеть хорошей скоростью чтения — на развитие
          этого навыка в модуле будет сделан особый упор.
          Ребёнок освоит эффективное чтение и сможет проработать печатную информацию на максимальной скорости (до 500
          слов в минуту) с полным пониманием и сохранением главных мыслей в долгосрочную память.</p>
        <p className={blocks.structure__blockResult}><strong>Результат модуля:</strong></p>
        <ul>
          <li><b>Умение быстро самостоятельно пройти материал целого учебника</b></li>
          <li><b>Навык скорочтения</b></li>
          <li><b>Навык постановки целей для работы с информацией</b></li>
          <li><b>Навык планирования образовательного процесса</b></li>
          <li><b>Освоение школьного материала: прохождение целого учебника на примере физики за 8 и 9 классы</b></li>
        </ul>
      </>
  },
  {
    bage: 'Модуль 7',
    title: 'Финишная прямая',
    description:
      <>
        <p>В этом модуле ребёнок, используя метод эффективного чтения, интенсивно отработает все освоенные техники. Мы ещё более плотно уложим все навыки в портфель инструментов — с этим багажом ребёнок может смело выходить в жизнь.
          Отныне он будет иметь неоспоримое преимущество перед теми, кто не владеет инструментами работы с информацией. Помните, что читающие люди, всегда будут руководить теми, кто чтению предпочитает телевизор.
          А те, кто умеет читать эффективно, имеют преимущество перед теми, кто этим навыком не владеет.</p>
        <p className={blocks.structure__blockResult}><strong>Результат модуля:</strong></p>
        <ul>
          <li><b>Навыки быстро ориентироваться в информационном потоке</b></li>
          <li><b>Навыки легко обрабатывать любую информацию и сохранять её в долговременной памяти</b></li>
        </ul>
        <div className={blocks.structure__blockTotal}>
          <p>По итогам курса ребёнок освоит техники и методы, которые позволят быстро и прочно запоминать, а также качественно воспроизводить не только школьный материал, но и любую адаптированную информацию.</p>
          <p>Например, он сможет легко запомнить 500 новых слов за один день или 200 дат за 2 — 3 часа.</p>
          <p>На основе этого опыта ребёнок осознает, что его возможности намного шире, чем он мог себе представить. Он сможет самостоятельно управлять своим развитием, что укрепит его мотивацию и веру в себя.</p>
          <p>У ребёнка сформируется целостное мышление — любую информацию он научится воспринимать как часть общего. Это позволит ему видеть источник проблем и находить решения в самых разных областях знаний.</p>
          <p>Мы стремимся, чтобы каждый студент научился управлять своей когнитивной деятельностью. Именно под эту задачу на наших курсах мы формируем портфель интеллектуальных навыков и компетенций.</p>
          <p>Студент научится анализировать задачи и оценивать усилия, необходимые для их решения. Он научится раскладывать большие задачи на преодолимые этапы и самостоятельно выстраивать путь к цели. Более широкий горизонт мышления позволит видеть вокруг себя неочевидные возможности.</p>
          <p>15% наших выпускников переходят на экстернат или самостоятельно осваивают новые профессии.</p>
        </div>
      </>
  }
];
